import { useEffect, useRef } from "react";
import CircularProgress from "@mui/material/CircularProgress";

import styles from "./styles";

const ChatMessage = ({ message, idx }) => {
  let style =
    message.username == "me" ? styles.ChatMessageMe : styles.ChatMessageYou;
  // merge styles.pre into s
  style = { ...style, ...styles.ChatMessage };

  return <div style={style}>{message.text}</div>;
};

const WaitingIndicator = () => {
  return (
    <div style={styles.WaitingIndicator}>
      <CircularProgress />
    </div>
  );
};

const AlwaysScrollToBottom = ({ refreshOn = [] }) => {
  const elementRef = useRef();

  useEffect(
    () =>
      elementRef.current.scrollIntoView({
        block: "nearest",
        inline: "nearest",
        behavior: "smooth",
      }),
    refreshOn
  );
  return <div ref={elementRef} />;
};

function ChatHistory({ loading, chatHistory }) {
  // See https://ordinarycoders.com/blog/article/react-chakra-ui for this neat trick to
  // make sure the latest message always appear in the right place.

  return (
    <div style={styles.ChatHistoryContainer} className="ChatHistoryContainer">
      <style
        dangerouslySetInnerHTML={{
          __html: `
.ChatHistoryContainer::-webkit-scrollbar {
    --webkit-appearance: none;
    width: 7px;
  };

  .ChatHistoryContainer::-webkit-scrollbar-thumb {
    border-radius: "4px;
    background-color: rgba(0, 0, 0, 0.5);
    box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
  };
`,
        }}
      />
      {chatHistory.map((message, idx) => (
        <ChatMessage key={message.id} message={message} idx={idx} />
      ))}
      {loading && <WaitingIndicator />}
      <AlwaysScrollToBottom refreshOn={[chatHistory, loading]} />
    </div>
  );
}

export default ChatHistory;
